import { CurrencyRate } from '@/api/currency/types/CurrencyRate'
import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

const parseFloatNum = (value: number | string) => {
  return parseFloat(value as unknown as string)
}

export const calcWeight = (width: number, length: number, height: number, weight: number) => {
  const volumetricWeight = (parseFloatNum(height) * parseFloatNum(length) * parseFloatNum(width)) / 5000

  if (volumetricWeight > weight) {
    const roundedVolumetricWeight = parseFloatNum(volumetricWeight).toFixed(1)
    return parseFloatNum(roundedVolumetricWeight)
  }

  const roundedWeight = parseFloatNum(weight).toFixed(1)
  return parseFloatNum(roundedWeight)
}

export const getUSDPrice = (item: { price: number; warehouse: PkgWarehouse }, EURToUSD: number, GBPToUSD: number, AEDToUSD: number) => {
  let conversionRate: number
  switch (item.warehouse) {
    case 'GR':
      conversionRate = EURToUSD
      break
    case 'USA':
      conversionRate = 1
      break
    case 'UK':
      conversionRate = GBPToUSD
      break
    case 'UAE':
      conversionRate = AEDToUSD
      break
    default:
      conversionRate = 1
  }

  return parseFloat(((item.price || 0) * conversionRate).toFixed(2))
}

/** Blended USD→ILS multiplier (90% Poalim×1.03 + 10% BOI), same as checkout pricing. */
export const getUsdToIlsMultiplier = (rates: Pick<CurrencyRate, 'poalimRate' | 'BOIrate'>) => {
  const poalim = Number(rates.poalimRate)
  const boi = Number(rates.BOIrate)
  return 0.9 * 1.03 * poalim + 0.1 * boi
}

export const convertUsdToIls = (usd: number, rates: Pick<CurrencyRate, 'poalimRate' | 'BOIrate'>) => usd * getUsdToIlsMultiplier(rates)

export const convertIlsToUsd = (ils: number, rates: Pick<CurrencyRate, 'poalimRate' | 'BOIrate'>) => {
  const multiplier = getUsdToIlsMultiplier(rates)
  if (multiplier <= 0) return 0
  return ils / multiplier
}

export const getLocalPriceFromUsd = (usd: number, warehouse: PkgWarehouse, EURToUSD: number, GBPToUSD: number, AEDToUSD: number) => {
  const usdRate = getUSDPrice({ price: 1, warehouse }, EURToUSD, GBPToUSD, AEDToUSD)
  if (usdRate === 0) return 0
  return parseFloat((usd / usdRate).toFixed(2))
}

export const getLocalPriceFromIls = (ils: number, warehouse: PkgWarehouse, rates: CurrencyRate) => {
  const usd = convertIlsToUsd(ils, rates)
  return getLocalPriceFromUsd(usd, warehouse, rates.EURToUSD, rates.GBPToUSD, rates.AEDToUSD)
}
export const getILSFromLocalPrice = (localPrice: number, warehouse: PkgWarehouse, rates: CurrencyRate) => {
  const usd = getLocalPriceFromUsd(localPrice, warehouse, rates.EURToUSD, rates.GBPToUSD, rates.AEDToUSD)
  const ils = convertUsdToIls(usd, rates)
  return parseFloat(ils.toFixed(2))
}
